type Props = { annual: boolean; onToggle: () => void };
export default function PricingToggle({ annual, onToggle }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center gap-4 mb-12">
      <span className={`text-sm font-medium ${!annual ? 'text-slate-900' : 'text-slate-400'}`}>{t('pricing.monthly')}</span>
      <button onClick={onToggle} className={`relative w-12 h-6 rounded-full transition-colors duration-200 ${annual ? 'bg-primary-600' : 'bg-slate-300'}`}>
        <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform duration-200 ${annual ? 'translate-x-6' : 'translate-x-0.5'}`} />
      </button>
      <span className={`text-sm font-medium flex items-center gap-2 ${annual ? 'text-slate-900' : 'text-slate-400'}`}>
        {t('pricing.annual')}
        <span className="bg-emerald-100 text-emerald-700 text-xs font-semibold px-2 py-0.5 rounded-full">{t('pricing.annual_badge')}</span>
      </span>
    </div>
  );
}
